import { render, staticRenderFns } from "./ColumnsSelectGroupItems.vue?vue&type=template&id=5979016c"
import script from "./ColumnsSelectGroupItems.vue?vue&type=script&lang=js"
export * from "./ColumnsSelectGroupItems.vue?vue&type=script&lang=js"
import style0 from "./ColumnsSelectGroupItems.vue?vue&type=style&index=0&id=5979016c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports